<div id="background">
    <div class="progress">
        <div class="progress-bar">
            <div class="progress-bar-fill" [style.width]="updateProgress + '%'"></div>
        </div>
        <span class="progress-label">{{ 'SPLASHSCREEN.UPDATING.INPROGRESS' | translate }}</span>
    </div>
</div>
